export default __webpack_public_path__ + "static/media/bird-bluetit.a2470867.svg";